import * as defaultSettings from "./default";
import * as nigeriaSettings from "./nigeria";

export const DEFAULT = defaultSettings;
export const NIGERIA = nigeriaSettings;

export * from "./global";

/*export { 
  DEFAULT_RESULTS_PER_PAGE as DEFAULT_RESULTS_PER_PAGE, 
  MAIN_SLIDER_NAVIGATION_MODE as MAIN_SLIDER_NAVIGATION_MODE,
  REQUEST_MAX_ATTEMPTS as REQUEST_MAX_ATTEMPTS, 
  REQUEST_RETRY_DELAY as REQUEST_RETRY_DELAY
} from "./global";
*/

